'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _validationConstants = require('../../../common/validation/validationConstants');

var ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.required,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    hideBeforeSubmit: true,
    hideIfTouched: true
};

/**
 * Returns an error object if a field's config states that the field is required, but the field does not have a value.
 * Otherwise, returns null.
 */

exports.default = function (fieldValue, validationConfig) {
    return validationConfig.required && !fieldValue ? _extends({}, ERROR_OBJECT, { fieldName: validationConfig.name }) : null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/requiredValidator.js
// module id = 2301
// module chunks = 0